angular.module("digitalLeasing.module").component("financialLeasingRequest", {
  templateUrl: "ng/components/digitalLeasing/financialLeasingRequest/financialLeasingRequest.view.html",
  bindings: {
    model: "=",
    // TODO eliminare tutte queste validazioni con una sola funzione che esporata la validazione dell'intera pagina
    validateContacts: "&",
    invalidateContacts: "&",
    validateFatturazione: "&",
    invalidateFatturazione: "&",
    validateCespite: "&",
    invalidateCespite: "&",
    validateTaxCreditFacility: "&",
    invalidateTaxCreditFacility: "&",
    portalRunned: "<",
    validateIban: "&",
    invalidateIban: "&",
    // fino a qui
    snapshot: '<',
    validateNewSection: '&',
    validateCcs: "&",
    invalidateCcs: "&"
  },
  controllerAs: "finLeasingRequestCtrl",
  controller: FinLeasingRequestController
});

function FinLeasingRequestController(
  $financialApiService,
  $portalService,
  $rootScope
) {
  var self = this;

  self.$onInit = function () {
    self.$portalService = $portalService;
    self.supportModel = {
      isStrumentale: false,
      isImmobiliare: false,
      cespiteIsNotOk: true,
      isArc: false,
      isM12: false,
      contatti: 0
    };

    if ($portalService.isAru()) {
      self.supportModel.isArc = true;
    } else if ($portalService.isAra()) {
      self.validateTaxCreditFacility();
    }

    if (getWizardMap(self.model.viewIndex) == "M12") {
      self.supportModel.isM12 = true;
    }
    if (getWizardMap(self.model.viewIndex) == "M15") {
      self.supportModel.isM15 = true;
    }

    if (self.supportModel.isArc && !self.supportModel.isM12) {
      if (self.model.leasingData.preventivo.prodotto.id === "IMC") {
        self.validateCespite();
        self.supportModel.cespiteIsNotOk = false;
      } else {

        var totalCespitiAmount = 0;
        self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
          totalCespitiAmount += parseInt(element.importoCespite);
        });

        totalCespitiAmount === self.model.leasingData.preventivo.importo ?
          self.supportModel.cespiteIsNotOk = false : self.supportModel.cespiteIsNotOk = true;

        if (!self.supportModel.cespiteIsNotOk) {
          self.validateCespite();
        }
      }

      self.ceckCespite();

    } else {
      //ARA
      self.validateCespite();
      self.supportModel.cespiteIsNotOk = false;
    }

    if (!self.model.leasingData.preventivo.questionarioAgv.exists) {
      self.validateTaxCreditFacility();
    }

    if (self.model.leasingData.preventivo.contatti.riferimenti.length > 0) {
      self.model.leasingData.preventivo.contatti.riferimenti.forEach(function (element) {
        if (element.id == "CLIENTE" &&
          !element.description && !element.email && !element.telefono) {
          retrieveClientContacts(self.model.financialCustomer.metadata.riUserG);
        }
      })
    } else {
      retrieveClientContacts(self.model.financialCustomer.metadata.riUserG);
    }
  };

  self.handlechange = function (property, value) {

    switch (property) {
      case "fornitore":
      case "contatti":
        self.model.leasingData.preventivo[property] = value;
        break;
      case "strumentale":
      case "immobiliare":
      case "flyNav":
        self.model.leasingData.preventivo.prodotto.bene.dettaglio[property] = value;
        break;
      case "dettaglio":
        self.model.leasingData.preventivo.prodotto.bene[property] = value;
        break;
      case "autorizzazione":
        self.model.leasingData.preventivo.prodotto.bene[property] = value;
        break;
      default:
        break;
    }
  };

  self.fattElettronica = function (value, result) {
    if (value) {
      if (result) {
        self.model.financialCustomer.metadata.riUserG.sedeFatturazione.fatturazione = value;
        console.log("Fatturazione: ", self.model.financialCustomer.metadata.riUserG.sedeFatturazione.fatturazione);
        self.validateFatturazione();
      } else {
        self.invalidateFatturazione();
      }
    }
  };

  self.contactsIsOk = function () {
    self.validateContacts();
  };

  self.contactsIsNotOk = function () {
    self.invalidateContacts();
  };

  self.taxComponentIsOk = function () {
    self.validateTaxCreditFacility();
  };

  self.taxComponentIsNotOk = function () {
    self.invalidateTaxCreditFacility();
  };

  self.ibanIsOk = function () {
    self.validateIban();
  };

  self.ibanIsNotOk = function () {
    self.invalidateIban();
  };

  self.validateAmount = function (amount) {
    parseFloat(amount) == parseFloat(self.model.leasingData.preventivo.importo) ?
      self.supportModel.cespiteIsNotOk = false : self.supportModel.cespiteIsNotOk = true;

    self.ceckCespite();
  }

  self.ceckCespite = function () {
    var allFieldAreOk = false;
    if (self.model.leasingData.preventivo.prodotto.beneContratto.length > 0) {
      self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
        if (element.cespiteIsOk) {
          allFieldAreOk = true;
        }
      });
    } else {
      //per il prodotto IMC beneContratto è vuoto
      allFieldAreOk = true;
    }
    var test = true;

    if ($portalService.isAru() && self.supportModel.isM12) {
      test = test && self.model.leasingData.preventivo.flagsArc.length && self.model.leasingData.preventivo.flagsArc
        .filter(function (e) {
          return e.value === 'SCOPO'
        })
        .every(function (element) {
          return element.selected == true;
        })
      if (self.model.leasingData.preventivo.prodotto.id === "IMC") {
        allFieldAreOk = true;
      }
    }

    if (!self.supportModel.cespiteIsNotOk && allFieldAreOk && test) {
      self.validateCespite();
    } else {
      self.invalidateCespite();
    }
  }

  var retrieveClientContacts = function (riUserG) {
    $financialApiService
      .getContattiCliente(riUserG)
      .then(function (response) {
        if (self.model.leasingData.preventivo.contatti.riferimenti.length > 0) {
          self.model.leasingData.preventivo.contatti.riferimenti.forEach(function (element) {
            if (element.id == "CLIENTE") {
              element.description = response.riferimenti[0].description;
              element.email = response.riferimenti[0].email;
              element.telefono = response.riferimenti[0].telefono;
            }
          });
        } else {
          self.model.leasingData.preventivo.contatti.riferimenti = response.riferimenti;
        }
        self.supportModel.contatti++;
      }).catch(function (error) {
        console.error(error);
      });
  }

  var getWizardMap = function (viewIndex) {
    return $rootScope.wizardMap.find(function (element) {
      return element.index == viewIndex;
    }).viewName;
  }

  var checkAllValidate = function () {
    var test =

      self.validateNewSection({
        validation: test
      })
  }
  self.handleStructureChange = function (property, value) {
    switch (property) {
      case "categoria":
        self.model.financialCustomer.metadata.codiceCategoria = value;
        break;
      case "firmaDigitale":
        self.model.leasingData.preventivo[property] = value;
        break;
      case "modalitaInvioDocumentazione":
        self.model.financialCustomer.metadata[property] = value;
        break;
      default:
        break;
    }
  };

  self.validateCheck = function() {
    self.validateCcs();
  }

  self.invalidateCheck = function() {
    self.invalidateCcs();
  }
}